
export enum Origin {
  Customer ="Customer",
  Advisor = "Advisor",
  MunicipalityEvaluator = "MunicipalityEvaluator"
}
